/**
 * Русские тексты редактора блоков страниц (`shared/components/Form/
 * PlatformBlocks`). Редактор общий для партнёрского и админского кабинетов:
 *
 * - партнёрский кабинет тянет переводы с бэкенда (namespace `partner`,
 *   сид `backend/src/migrations/data/partnerSeed/platformBlocks.ts`), поэтому
 *   этот словарь там не используется;
 * - админка полностью русская и без сетевых переводов — она поднимает
 *   локальный i18next-инстанс на этих ресурсах (`admin/app/providers/i18n.ts`).
 *
 * Ключи и значения ветки `ru` обязаны совпадать с сид-фрагментом бэкенда:
 * backend не может импортировать код кабинета, поэтому русские строки там
 * продублированы один в один.
 */
export const platformBlocksRu = {
  list: {
    empty: "Компоненты еще не добавлены",
  },
  item: {
    reorder: "Перетащите для изменения порядка",
    edit: "Редактировать",
    delete: "Удалить",
    notRendered: "Не отображается на витрине",
  },
  dialog: {
    title: "Компонент",
    newTitle: "Новый компонент",
    editTitle: "Редактировать компонент",
    selectContent: "Выберите содержимое для компонента",
    back: "Назад",
    next: "Далее",
    cancel: "Отмена",
    save: "Сохранить",
    create: "Создать",
    tabs: {
      settings: "Настройки",
      visibility: "Видимость",
    },
  },
  visibility: {
    countriesTitle: "Видимость по странам",
    platformsTitle: "Видимость на платформах",
    usersTitle: "Видимость пользователям",
    typeLabel: "Тип",
    countriesLabel: "Страны",
    platformsLabel: "Платформа",
  },
  view: {
    CAROUSEL: "Карусель",
    GRID: "Сетка",
    LIST: "Список",
  },
  align: {
    left: "Слева",
    center: "По центру",
    right: "Справа",
    justify: "По ширине",
  },
  previewMode: {
    HORIZONTAL: "Горизонтальная (16:9)",
    VERTICAL: "Вертикальная (2:3)",
  },
  sort: {
    LATEST: "Сначала новые",
    OLDEST: "Сначала старые",
    UPDATED: "Недавно обновлённые",
    MANUAL: "Вручную",
    TITLE: "По названию",
  },
  contentType: {
    VIDEO: "Видео",
    STREAM: "Стрим",
    COLLECTION: "Коллекции",
  },
  streamStatus: {
    PENDING: "Предстоящий",
    STARTED: "Идёт сейчас",
    FINISHED: "Завершён",
  },
  productType: {
    PPV: "Разовая покупка",
    SUBSCRIPTION: "Подписка",
  },
  textColor: {
    primary: "Основной",
    secondary: "Вторичный",
    textPrimary: "Основной текст",
    textSecondary: "Вторичный текст",
  },
  buttonColor: {
    primary: "Основной",
    secondary: "Вторичный",
    default: "По умолчанию",
  },
  buttonVariant: {
    default: "По умолчанию",
    contained: "Заполненный",
    outlined: "С обводкой",
  },
  buttonSize: {
    small: "Маленький",
    medium: "Средний",
    large: "Большой",
  },
  postsVariant: {
    TITLE_INSIDE: "Заголовок внутри",
    TITLE_OUTSIDE: "Заголовок снаружи",
  },
  fields: {
    title: "Заголовок",
    name: "Название",
    text: "Текст",
    url: "URL",
    link: "Ссылка",
    image: "Изображение",
    icon: "Иконка",
    logo: "Логотип",
    variant: "Вариант",
    color: "Цвет",
    textColor: "Цвет текста",
    backgroundColor: "Цвет фона",
    align: "Выравнивание",
    nameAlign: "Выравнивание названия",
    size: "Размер",
    paddingTop: "Отступ сверху (px)",
    paddingBottom: "Отступ снизу (px)",
    maxWidth: "Максимальная ширина (px)",
    maxWidthShort: "Макс. ширина (px)",
    fullWidth: "На всю ширину",
    openInNewWindow: "Открывать в новом окне",
    view: "Вид",
    displayView: "Вид отображения",
    itemsPerRow: "Карточек в ряд",
    itemsInRow: "Элементов в строке",
    limit: "Количество",
    totalItems: "Элементов всего",
    sort: "Сортировка",
    previewMode: "Ориентация превью",
    contentType: "Тип контента",
    productType: "Тип продукта",
    streamStatus: "Статус трансляции",
    tags: "Теги",
    tagsAll: "Теги (все из списка)",
    tagsAny: "Теги (любой из списка)",
    collectionTypes: "Типы коллекций",
    moreUrl: "Своя ссылка «Показать всё»",
    moreText: "Текст кнопки «смотреть ещё»",
    loadMoreOnScroll: "Догрузка при прокрутке",
    loadMore: "Загрузить еще",
    hideShowAll: "Скрыть «Показать всё»",
    useCurrentTag: "Фильтровать по тегу текущей страницы",
    useCurrentTagHelper: "Работает только на странице, назначенной тегу",
    tagTypes: "Типы тегов",
  },
  html: {
    code: "HTML код",
  },
  faq: {
    question: "Вопрос",
    answer: "Ответ",
    addQuestion: "Добавить вопрос",
  },
  redirect: {
    url: "URL для перенаправления",
  },
  itemsList: {
    addItem: "Добавить элемент",
  },
  partners: {
    addPartner: "Добавить партнёра",
  },
  collections: {
    sortLabel: "Порядок коллекций",
    limitLabel: "Коллекций за раз",
  },
  services: {
    serviceTypes: "Тип услуг",
  },
  tagCard: {
    tag: "Тег",
    tagPlaceholder: "Выберите тег",
    maxWidth: "Максимальная ширина (опционально)",
    maxWidthHelper:
      "Максимальная ширина контейнера: sm, md, lg, xl. По умолчанию: md",
  },
  customCover: {
    notice:
      "Компонент не требует настройки. Для добавления слайдов перейдите в раздел Обложки.",
    openSection: "Открыть раздел",
  },
  personalContents: {
    moreUrl: "Ссылка «Ещё»",
    moreUrlHelper: "Необязательный URL для стрелки рядом с заголовком полки",
  },
  archive: {
    tabsTagType: "Тип тега для вкладок",
    tabsTagTypeHelper: "Теги этого типа станут вкладками над каталогом",
    tabsTagIds: "Теги вкладок по порядку",
    tabsTagIdsHelper: "Порядок выбора тегов задаёт порядок вкладок",
    allVideosText: "Подпись вкладки со всем видео",
    allVideosTextHelper:
      "Если не заполнено, подпись берётся из переводов витрины",
    addFilterTagType: "Добавить фильтр",
    filterTagType: "Тип тега фильтра",
    filterTagTypeOrder: "Порядок тегов",
    filterTagsBySelectedTags: "Сужать варианты фильтров уже выбранными тегами",
    pinnedTagIds: "Закреплённые теги",
    pinnedTagIdsHelper: "Применяются вместе с тегами, которые выберет зритель",
    showAdvancedFilters:
      "Показывать расширенные фильтры (дата загрузки, длительность)",
    showSearch: "Показывать поле поиска",
    notYetOnSite: "Настройка применится на витрине",
  },
  types: {
    TEXT: {
      label: "Текст",
      description: "Текстовый блок с форматированием",
    },
    HTML: { label: "HTML" },
    BUTTON: { label: "Кнопка" },
    MARKDOWN: { label: "Markdown" },
    FAQ: { label: "FAQ" },
    BANNER: { label: "Баннер" },
    REDIRECT: { label: "Редирект" },
    FAST_LINKS_LIST: { label: "Быстрые ссылки" },
    APPS_LIST: { label: "Список приложений" },
    PARTNERS: {
      label: "Партнёры",
      description: "Логотипы партнёров со ссылками",
    },
    TAG_CARD: { label: "Карточка тега" },
    SERVICES: { label: "Услуги" },
    PACKAGES: { label: "Пакеты" },
    CUSTOM_COVER: { label: "Обложка" },
    POSTS: { label: "Статьи" },
    CONTENTS: { label: "Видео" },
    PRODUCTS: { label: "Продукты" },
    FAVORITE_CONTENTS: {
      label: "Избранное",
      description: "Видео, сохранённые зрителем в избранное",
    },
    CONTINUE_WATCHING_CONTENTS: {
      label: "Продолжить просмотр",
      description: "Недосмотренные зрителем видео",
    },
    ITEMS_LIST: { label: "Список элементов" },
    TAGS: {
      label: "Теги (полка)",
      description: "Полка или сетка карточек тегов: жанры, персоны, категории",
    },
    ARCHIVE: {
      label: "Архив видео",
      description:
        "Каталог всего видео платформы с вкладками и фильтрами по тегам",
    },
  },
  contentsLabel: {
    CAROUSEL: {
      VIDEO: "Карусель видео",
      STREAM: "Карусель стримов",
      COLLECTION: "Карусель коллекций",
    },
    GRID: {
      VIDEO: "Сетка видео",
      STREAM: "Сетка стримов",
      COLLECTION: "Сетка коллекций",
    },
    LIST: {
      VIDEO: "Список видео",
      STREAM: "Список стримов",
      COLLECTION: "Список коллекций",
    },
  },
};
